import "./polyfill";
// import './util/sentry';

import Vue from 'vue';

import {
    AlertPlugin,
    BDropdown,
    BDropdownDivider,
    BDropdownItem,
    CollapsePlugin,
    FormFilePlugin,
    FormRadioPlugin,
    FormTextareaPlugin,
    ModalPlugin,
    TabsPlugin,
} from 'bootstrap-vue';

import FormDatePicker from "./components/FormDatePicker";

import directives from "./directives";

// vendor plugins
import {VueMasonryPlugin} from 'vue-masonry/dist/vue-masonry-plugin-umd';
import VueSocialSharing from 'vue-social-sharing';
import Formoj from 'formoj';
// import './cursus';

// own components
import components from './components';

import './api';
// css
import 'swiper/dist/css/swiper.min.css';


// use vendor plugins
Vue.use(VueMasonryPlugin);
Vue.use(VueSocialSharing);
Vue.use(Formoj, {
    scrollOffset: 160, // offset the height of header
});


// bootstrap-vue
Vue.use(FormRadioPlugin);
Vue.use(FormFilePlugin);
Vue.use(CollapsePlugin);
Vue.use(ModalPlugin);
Vue.use(AlertPlugin);
Vue.use(FormTextareaPlugin);
Vue.use(TabsPlugin);
Vue.component('b-dropdown', BDropdown);
Vue.component('b-dropdown-divider', BDropdownDivider);
Vue.component('b-dropdown-item', BDropdownItem);
// overridden date picker
Vue.component('b-form-datepicker', FormDatePicker);


Vue.component('swiper', () => import(/* webpackChunkName: 'vue-swiper' */'vue-awesome-swiper').then(module => module.swiper));
Vue.component('swiper-slide', () => import(/* webpackChunkName: 'vue-swiper' */'vue-awesome-swiper').then(module => module.swiperSlide));


Object.keys(components).forEach((name) => {
    Vue.component(name, components[name]);
});

new Vue({
    el: '#app',
    methods: {
        focus,
    },
    created() {
        // fix social links do not open on ios
        if(/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
            window.open = (href, target) => Object.assign(document.createElement('a'), { target, href }).click()
        }
        document.querySelector('.header')?.classList.remove('collapsed');
    },
    directives,
});
